const placeholderComponent = {
  init() {
    console.log('placeholderComponent init() - this:', this);
  },

  tick(time, deltaTime) {
    this.el.object3D.rotateY(0.001 * deltaTime);
  },
};

export default placeholderComponent ;
